import { ReactNode } from 'react';

const CompareLayout = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};

export default [CompareLayout];
